<template>
  <div class="banner">
    <img :src="require('@/assets/images/general/horizontal-white.svg')" />
  </div>
</template>
<script>
export default {
  name: "Banner"
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-top: calc(#{$nav-height} + 120px);
  padding-bottom: 150px;
  @media (max-width: $sm) {
		padding-bottom: 75px;
	}
}
</style>